<template>
  <b-container>
    <b-row>
      <b-col v-if="dynamicFields.length > 0" md="12">
        <b-row v-if="dynamicFields.length > 0">
          <b-col md="6">
            <b-row v-for="(field, index) in splitFields[0]" :key="index" class="mb-3">
              <b-col md="12">
                <b-form-group>
                  <h6>
                    <i class="fa fa-angle-down"></i> {{ field.FAMCOML_STR }}
                    <span style="color: red">*</span>
                  </h6>
                  <b-form-select v-if="field.FAMCOML_TYPE === 'liste' && field.FAMCOML_LISTE_VALEURS"
                    :id="field.FAMCOML_STR" v-model="fieldValues[field.FAMCOML_STR]"
                    :options="getListeOptions(field.FAMCOML_LISTE_VALEURS)" :placeholder="`Sélectionner une valeur`"
                    @change="saveDynamicFieldsToSession"></b-form-select>
                  <b-form-input v-else-if="field.FAMCOML_TYPE === 'date'" :id="field.FAMCOML_STR"
                    v-model="fieldValues[field.FAMCOML_STR]" type="date" :placeholder="`Entrer une date`"
                    @input="saveDynamicFieldsToSession"></b-form-input>
                  <div v-else-if="field.FAMCOML_TYPE === 'date_heure'"
                    class="d-flex flex-column flex-md-row align-items-stretch">
                    <b-form-input :id="`${field.FAMCOML_STR}-date`" :value="getDatePart(field.FAMCOML_STR)"
                      type="date" :placeholder="`Entrer une date`"
                      class="mb-2 mb-md-0 mr-md-2" @input="updateDateTime(field.FAMCOML_STR, $event, 'date')">
                    </b-form-input>
                    <b-form-input :id="`${field.FAMCOML_STR}-time`" :value="getTimePart(field.FAMCOML_STR)"
                      type="time" :placeholder="`Entrer une heure`" @input="updateDateTime(field.FAMCOML_STR, $event, 'time')">
                    </b-form-input>
                  </div>
                  <b-form-checkbox v-else-if="field.FAMCOML_TYPE === 'case à cocher'" :id="field.FAMCOML_STR"
                    v-model="fieldValues[field.FAMCOML_STR]" @change="saveDynamicFieldsToSession">
                    {{ field.FAMCOML_STR }}
                  </b-form-checkbox>
                  <b-form-input v-else :id="field.FAMCOML_STR" v-model="fieldValues[field.FAMCOML_STR]" type="text"
                    :placeholder="`Entrer une valeur pour ${field.FAMCOML_STR}`"
                    @input="saveDynamicFieldsToSession"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="6">
            <b-row v-for="(field, index) in splitFields[1]" :key="index + splitFields[0].length" class="mb-3">
              <b-col md="12">
                <b-form-group>
                  <h6>
                    <i class="fa fa-angle-down"></i> {{ field.FAMCOML_STR }}
                    <span style="color: red">*</span>
                  </h6>
                  <b-form-select v-if="field.FAMCOML_TYPE === 'liste' && field.FAMCOML_LISTE_VALEURS"
                    :id="field.FAMCOML_STR" v-model="fieldValues[field.FAMCOML_STR]"
                    :options="getListeOptions(field.FAMCOML_LISTE_VALEURS)" :placeholder="`Sélectionner une valeur`"
                    @change="saveDynamicFieldsToSession"></b-form-select>
                  <b-form-input v-else-if="field.FAMCOML_TYPE === 'date'" :id="field.FAMCOML_STR"
                    v-model="fieldValues[field.FAMCOML_STR]" type="date" :placeholder="`Entrer une date`"
                    @input="saveDynamicFieldsToSession"></b-form-input>
                  <div v-else-if="field.FAMCOML_TYPE === 'date_heure'"
                    class="d-flex flex-column flex-md-row align-items-stretch">
                    <b-form-input :id="`${field.FAMCOML_STR}-date`" :value="getDatePart(field.FAMCOML_STR)"
                      type="date" :placeholder="`Entrer une date`"
                      class="mb-2 mb-md-0 mr-md-2" @input="updateDateTime(field.FAMCOML_STR, $event, 'date')">
                    </b-form-input>
                    <b-form-input :id="`${field.FAMCOML_STR}-time`" :value="getTimePart(field.FAMCOML_STR)"
                      type="time" :placeholder="`Entrer une heure`" @input="updateDateTime(field.FAMCOML_STR, $event, 'time')">
                    </b-form-input>
                  </div>
                  <b-form-checkbox v-else-if="field.FAMCOML_TYPE === 'case à cocher'" :id="field.FAMCOML_STR"
                    v-model="fieldValues[field.FAMCOML_STR]" @change="saveDynamicFieldsToSession">
                    {{ field.FAMCOML_STR }}
                  </b-form-checkbox>
                  <b-form-input v-else :id="field.FAMCOML_STR" v-model="fieldValues[field.FAMCOML_STR]" type="text"
                    :placeholder="`Entrer une valeur pour ${field.FAMCOML_STR}`"
                    @input="saveDynamicFieldsToSession"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <!-- Ajout du champ Commentaire si origineCom est 'LABO' -->
            <b-row v-if="origineCom === 'LABO'" class="mb-3">
              <b-col md="12">
                <h6>
                  <i class="fa fa-angle-down"></i> Commentaire Labo
                  <span style="color: red">*</span>
                </h6>
                <b-form-input
                  id="Commentaire Labo"
                  v-model="fieldValues['Commentaire']"
                  placeholder="Entrer un commentaire"
                  type="text"
                  @input="saveDynamicFieldsToSession"
                ></b-form-input>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
      <b-col v-else md="12">
        <p>Aucun champ à afficher.</p>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import api from './../api.js'

export default {
  name: 'CommentaireLabo',
  props: {
    origineCom: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isSac: false,
      family: false,
      dynamicFields: [], // Liste des champs récupérés dynamiquement
      fieldValues: {} // Stocke les valeurs des inputs
    }
  },
  methods: {
    fetchFields (centFam) {
      return api.getLabcoCommentByFamily(centFam)
        .then((response) => {
          const labcoComment = response.labcoComment || []
          // Filtrer selon la prop origine
          console.log('Origine:', this.origineCom)
          const filteredFields = labcoComment.filter(
            field => field.FAMCOML_ORIGINE === this.origineCom
          )
          this.dynamicFields = filteredFields
          // Initialise les valeurs des champs
          this.dynamicFields.forEach((field) => {
            this.$set(this.fieldValues, field.FAMCOML_STR, '')
          })
          console.log('Champs dynamiques chargés:', this.dynamicFields.length)
          return this.dynamicFields
        })
        .catch((error) => {
          console.error('Error fetching fields:', error)
          throw error
        })
    },
    getListeOptions (listeValeurs) {
      return listeValeurs
        ? listeValeurs.split(';').map(val => ({ value: val, text: val }))
        : []
    },
    logFieldValues () {
      console.log('fieldValues:', this.fieldValues)
    },
    saveDynamicFieldsToSession () {
      let enregistrement = {}
      try {
        enregistrement = JSON.parse(sessionStorage.getItem('enregistrement')) || {}
      } catch (e) {
        enregistrement = {}
      }
      // Ajout : stocker CENT_FORFAIT directement (extraire uniquement le nombre)
      if ('Forfait' in this.fieldValues) {
        const forfaitValue = this.fieldValues['Forfait']
        // Regex pour extraire le nombre avant le tiret (avec ou sans espace)
        // Formats supportés: "xxx-description", "xxx - description", "xxx"
        const match = String(forfaitValue).match(/^(\d+)/)
        enregistrement.CENT_FORFAIT = match ? parseInt(match[1], 10) : null
      }
      // Concatène uniquement les champs non vides
      const commentairesArr = Object.entries(this.fieldValues)
        .filter(([key, value]) => key !== 'Forfait' && value !== '' && value !== null && value !== undefined)
        .map(([key, value]) => `${key}: ${value}`)
      // Format: '|valeur |valeur2 |valeur3 ' (pipe at start and before each value, space at end)
      const commentaires = commentairesArr.length > 0 ? '|' + commentairesArr.join(' |') + ' ' : null

      if (this.origineCom === 'LABO') {
        enregistrement.CENT_COMMENT_APPLI_LABO = commentaires
      } else if (this.origineCom === 'CLIENT') {
        enregistrement.CENT_COMMENT_APPLI = commentaires
      }
      sessionStorage.setItem('enregistrement', JSON.stringify(enregistrement))
    },
    getDatePart (key) {
      const value = this.fieldValues[key]
      if (!value) return ''
      const stringValue = String(value).trim()

      // Format ISO avec T : YYYY-MM-DDTHH:MM:SS
      if (stringValue.includes('T')) {
        const [date] = stringValue.split('T')
        if (/^\d{4}-\d{2}-\d{2}$/.test(date)) return date
      }

      // Format ISO simple : YYYY-MM-DD
      if (/^\d{4}-\d{2}-\d{2}$/.test(stringValue)) return stringValue

      // Format DD/MM/YYYY - conversion vers YYYY-MM-DD
      const ddmmyyyy = stringValue.match(/^(\d{2})\/(\d{2})\/(\d{4})/)
      if (ddmmyyyy) {
        const [, day, month, year] = ddmmyyyy
        return `${year}-${month}-${day}`
      }

      return ''
    },
    getTimePart (key) {
      const value = this.fieldValues[key]
      if (!value) return ''
      const stringValue = String(value).trim()

      // Format ISO avec T : YYYY-MM-DDTHH:MM:SS
      if (stringValue.includes('T')) {
        const [, time = ''] = stringValue.split('T')
        const timePart = time.slice(0, 5) // Format HH:MM
        if (/^\d{2}:\d{2}$/.test(timePart)) return timePart
      }

      // Format HH:MM ou HH:MM:SS
      if (/^\d{2}:\d{2}/.test(stringValue)) {
        return stringValue.slice(0, 5) // Format HH:MM
      }

      return ''
    },
    updateDateTime (key, newValue, part) {
      // Extraire la valeur de l'événement de manière robuste
      const eventValue = newValue && newValue.target ? newValue.target.value : String(newValue || '')
      const inputValue = eventValue.trim()
      const currentValue = this.fieldValues[key] ? String(this.fieldValues[key]).trim() : ''

      let currentDate = ''
      let currentTime = ''

      // Parser la valeur actuelle
      if (currentValue.includes('T')) {
        const [storedDate = '', storedTime = ''] = currentValue.split('T')
        currentDate = storedDate
        currentTime = storedTime.slice(0, 5)
      } else if (/^\d{4}-\d{2}-\d{2}$/.test(currentValue)) {
        currentDate = currentValue
      } else if (/^\d{2}:\d{2}/.test(currentValue)) {
        currentTime = currentValue.slice(0, 5)
      } else {
        // Parser format DD/MM/YYYY HH:mm
        const ddmmyyyyMatch = currentValue.match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})/)
        if (ddmmyyyyMatch) {
          const [, day, month, year, hours, minutes] = ddmmyyyyMatch
          currentDate = `${year}-${month}-${day}`
          currentTime = `${hours}:${minutes}`
        }
      }

      // Mettre à jour la partie modifiée
      if (part === 'date') {
        currentDate = inputValue
      } else if (part === 'time') {
        currentTime = inputValue.slice(0, 5)
      }

      // Combiner avec le format ISO correct
      const combinedValue = currentDate && currentTime
        ? `${currentDate}T${currentTime}`
        : currentDate || currentTime

      this.$set(this.fieldValues, key, combinedValue)
      this.saveDynamicFieldsToSession()
    },
    setFieldValue (key, value) {
      // Méthode pour définir la valeur d'un champ dynamique
      // Utilisée lors du pré-remplissage en mode édition
      if (!key || value === undefined || value === null) return
      // Trouver le champ correspondant dans les champs dynamiques
      // Essayer plusieurs correspondances : FAMCOML_STR, FAMCOML_LIBELLE, ou correspondance approximative
      let field = this.dynamicFields.find(f => f.FAMCOML_STR === key)
      // Si pas trouvé par FAMCOML_STR, essayer par FAMCOML_LIBELLE
      if (!field && this.dynamicFields.some(f => f.FAMCOML_LIBELLE)) {
        field = this.dynamicFields.find(f => f.FAMCOML_LIBELLE === key)
      }
      // Si toujours pas trouvé, essayer une correspondance approximative (insensible à la casse)
      if (!field) {
        field = this.dynamicFields.find(f =>
          (f.FAMCOML_STR && f.FAMCOML_STR.toLowerCase() === key.toLowerCase()) ||
          (f.FAMCOML_LIBELLE && f.FAMCOML_LIBELLE.toLowerCase() === key.toLowerCase())
        )
      }
      // Correspondance encore plus souple : chercher des mots-clés
      if (!field) {
        const keyLower = key.toLowerCase()
        field = this.dynamicFields.find(f => {
          const strLower = (f.FAMCOML_STR || '').toLowerCase()
          const libelleLower = (f.FAMCOML_LIBELLE || '').toLowerCase()
          // Correspondances spécifiques connues
          if (keyLower.includes('température') && (strLower.includes('temp') || libelleLower.includes('temp'))) return true
          if (keyLower.includes('conditionnement') && (strLower.includes('condition') || libelleLower.includes('condition'))) return true
          if (keyLower.includes('etat') && keyLower.includes('physique') && (strLower.includes('etat') || libelleLower.includes('etat'))) return true
          if (keyLower.includes('prélèvement') && (strLower.includes('prele') || libelleLower.includes('prele'))) return true
          if (keyLower === 'commentaire' && (strLower.includes('comment') || libelleLower.includes('comment'))) return true
          return false
        })
      }
      // Cas spécial pour le champ "Commentaire" qui correspond à "Commentaire Labo"
      if (!field && key === 'Commentaire' && this.origineCom === 'LABO') {
        // Traitement direct pour le champ commentaire labo
        this.$set(this.fieldValues, 'Commentaire', String(value))
        this.saveDynamicFieldsToSession()
        console.log(`Champ spécial rempli: ${key} = ${value}`)
        return
      }
      // Cas spécial pour le champ "Forfait" - chercher l'option complète dans la liste
      if (!field && key === 'Forfait') {
        field = this.dynamicFields.find(f => f.FAMCOML_STR === 'Forfait')
        if (field && field.FAMCOML_LISTE_VALEURS) {
          const options = field.FAMCOML_LISTE_VALEURS.split(';')
          const forfaitNumber = String(value).trim()
          const forfaitMatch = options.find(opt => {
            const match = opt.match(/^(\d+)/)
            return match && match[1] === forfaitNumber
          })
          this.$set(this.fieldValues, 'Forfait', forfaitMatch || value)
          this.saveDynamicFieldsToSession()
          console.log(`Champ spécial Forfait rempli: ${value} -> ${forfaitMatch || value}`)
          return
        }
      }
      if (!field) {
        console.warn(`Champ dynamique non trouvé: ${key}`)
        console.log('Champs dynamiques disponibles:', this.dynamicFields.map(f => ({ str: f.FAMCOML_STR, libelle: f.FAMCOML_LIBELLE })))
        return
      }
      let processedValue = value
      // Traitement selon le type de champ
      switch (field.FAMCOML_TYPE) {
        case 'case à cocher':
          // Pour les cases à cocher, convertir les valeurs textuelles en boolean
          processedValue = ['true', 'oui', 'yes', '1', 'on', 'vrai'].includes(String(value).toLowerCase())
          break
        case 'liste':
          // Pour les listes, vérifier que la valeur existe dans les options
          if (field.FAMCOML_LISTE_VALEURS) {
            const options = field.FAMCOML_LISTE_VALEURS.split(';')
            // Cas spécial pour Forfait : si la valeur est un nombre (string ou int), chercher l'option qui commence par ce nombre
            if (field.FAMCOML_STR === 'Forfait' && /^\d+$/.test(String(value).trim())) {
              const forfaitNumber = String(value).trim()
              const forfaitMatch = options.find(opt => {
                const match = opt.match(/^(\d+)/)
                return match && match[1] === forfaitNumber
              })
              processedValue = forfaitMatch || value
              console.log(`Forfait chargé: ${value} -> ${processedValue}`, { options, forfaitNumber })
            } else {
              // Chercher une correspondance exacte ou approximative
              const exactMatch = options.find(opt => opt === value)
              const partialMatch = options.find(opt =>
                opt.toLowerCase().includes(String(value).toLowerCase()) ||
                String(value).toLowerCase().includes(opt.toLowerCase())
              )
              processedValue = exactMatch || partialMatch || value
            }
          }
          break
        case 'date':
          // Pour les dates, s'assurer du format YYYY-MM-DD
          if (value && typeof value === 'string') {
            // Si c'est déjà au bon format, garder tel quel
            if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
              processedValue = value
            } else {
              // Essayer de parser format date qui est en bdd dans le champ CENT_COMMENT_APPLI_LABO DD/MM/YYYY
              const isoDateTimeMatch = value.match(/^(\d{2})\/(\d{2})\/(\d{4})/)
              if (isoDateTimeMatch) {
                const [, day, month, year] = isoDateTimeMatch
                processedValue = `${year}-${month}-${day}`
              }
            }
          }
          break
        case 'date_heure':
          // Pour les dates et heures, s'assurer du format YYYY-MM-DDTHH:MM
          if (value) {
            const stringValue = String(value).trim()

            // Format ISO correct : YYYY-MM-DDTHH:MM ou YYYY-MM-DDTHH:MM:SS
            if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(stringValue)) {
              processedValue = stringValue.slice(0, 16) // Garder YYYY-MM-DDTHH:MM
            } else {
              // Format DD/MM/YYYY HH:mm (base de données)
              const ddmmyyyyMatch = stringValue.match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})/)
              if (ddmmyyyyMatch) {
                const [, day, month, year, hours, minutes] = ddmmyyyyMatch
                processedValue = `${year}-${month}-${day}T${hours}:${minutes}`
              } else {
                // Format DD/MM/YYYY HH:mm:ss
                const ddmmyyyysMatch = stringValue.match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})/)
                if (ddmmyyyysMatch) {
                  const [, day, month, year, hours, minutes] = ddmmyyyysMatch
                  processedValue = `${year}-${month}-${day}T${hours}:${minutes}`
                } else {
                  // Essayer format avec tiret : DD-MM-YYYY HH:mm
                  const ddmmyyyy2Match = stringValue.match(/^(\d{2})-(\d{2})-(\d{4}) (\d{2}):(\d{2})/)
                  if (ddmmyyyy2Match) {
                    const [, day, month, year, hours, minutes] = ddmmyyyy2Match
                    processedValue = `${year}-${month}-${day}T${hours}:${minutes}`
                  }
                }
              }
            }
          }
          break
        default:
          // Pour les champs texte, garder la valeur telle quelle
          processedValue = String(value)
          break
      }
      // Mettre à jour la valeur de manière réactive en utilisant l'identifiant correct du champ
      const fieldKey = field.FAMCOML_STR
      this.$set(this.fieldValues, fieldKey, processedValue)
      // Sauvegarder automatiquement en session après la mise à jour
      this.saveDynamicFieldsToSession()
      console.log(`Champ rempli: ${key} -> ${fieldKey} = ${processedValue} (type: ${field.FAMCOML_TYPE})`)
    }
  },
  computed: {
    splitFields () {
      const mid = Math.ceil(this.dynamicFields.length / 2)
      return [
        this.dynamicFields.slice(0, mid),
        this.dynamicFields.slice(mid)
      ]
    }
  }
}
</script>

<style>
.field-container {
  margin-bottom: 10px
}
</style>



// WEBPACK FOOTER //
// src/components/CommentaireLabo.vue